<template>
  <div>
    <div class="card card--primary-color card--form mb-3">
      <div class="card-header">
        <h4>{{ title }}</h4>
      </div>
      <div class="card-body">
        <customer-media-upload
          class="mb-3"
          :customer-profile="profile.id"
        ></customer-media-upload>
        <upload-modal></upload-modal>
        <user-record-audio
          class="mb-3"
          :media_update_url="profile.media_update_url"
        ></user-record-audio>
        <h3 v-if="recentlyUploadedMedia.length > 0">Hinzugefügt</h3>
        <div class="mb-3">
          <customer-media
            :media="recentlyUploadedMedia"
            :update-url="profile.media_update_url"
            :isFake="profile.is_fake"
          ></customer-media>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header"><h4>Fotos</h4></div>
          <div class="card-body">
            <ul class="list-group">
              <li
                v-for="picture in pictures"
                :key="picture.id"
                class="list-group-item"
              >
                <div class="d-flex">
                  <div>
                    <span class="badge badge-secondary badge-pill">{{
                      picture.id
                    }}</span>
                    <img :src="`${picture.url}?width=55&height=55`" />
                    <span v-if="picture.is_erotic">
                      <span class="badge badge-primary badge-pill"
                        >Erotisch</span
                      >
                    </span>
                    <span v-else>
                      <span class="badge badge-primary badge-pill"
                        >Öffentlich</span
                      >
                    </span>
                  </div>
                  <div class="flex-grow-1 text-center">
                    {{ picture.path }} <br />
                    {{ picture.file_size }}
                  </div>
                  <a :href="picture.url" target="_blank" class="btn btn-primary"
                    ><i class="far fa-image"></i
                    ><i class="fas fa-search-plus"></i
                  ></a>
                  <customer-media-edit
                    :entry="picture"
                    :isFake="profile.is_fake"
                  ></customer-media-edit>
                  <v-button
                    :request="
                      () => {
                        return destroy(picture);
                      }
                    "
                    class="btn btn-danger"
                  >
                    <i class="fas fa-times"></i>
                  </v-button>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header"><h4>Sprachnachrichten</h4></div>
          <div class="card-body">
            <ul class="list-group">
              <li
                v-for="audioFile in audioFiles"
                :key="audioFile.id"
                class="list-group-item"
              >
                <div class="row">
                  <div class="col-3">
                    <div class="d-flex">
                      <div>
                        <span class="badge badge-secondary badge-pill">{{
                          audioFile.id
                        }}</span>
                        <audio
                          style="width: 200px;"
                          :src="audioFile.url"
                          controls
                        ></audio>
                        <span v-if="audioFile.is_erotic">
                          <span class="badge badge-primary badge-pill"
                            >Erotisch</span
                          >
                        </span>
                        <span v-else>
                          <span class="badge badge-primary badge-pill"
                            >Öffentlich</span
                          >
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 text-center">
                    {{ audioFile.path }} <br />
                    {{ audioFile.file_size }}
                  </div>
                  <div class="col-3">
                    <div class="row">
                      <a
                        :href="audioFile.url"
                        target="_blank"
                        class="btn btn-primary"
                        ><i class="far fa-image"></i
                        ><i class="fas fa-search-plus"></i
                      ></a>
                      <customer-media-edit
                        :entry="audioFile"
                        :isFake="profile.is_fake"
                      ></customer-media-edit>
                      <v-button
                        :request="
                          () => {
                            return destroy(audioFile);
                          }
                        "
                        class="btn btn-danger"
                      >
                        <i class="fas fa-times"></i>
                      </v-button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <description-card v-model="profile"></description-card>
      </div>
    </div>
  </div>
</template>
<script>
import UserRecordAudio from "@/components/Customer/UserRecordAudio.vue";
import CustomerMediaEdit from "@/components/CustomerMediaEdit.vue";
import DescriptionCard from "src/components/UIComponents/Cards/DescriptionCard.vue";

export default {
  components: {
    UserRecordAudio,
    CustomerMediaEdit,
    DescriptionCard
  },
  data() {
    return {
      media: [],
      recentlyUploadedMedia: []
    };
  },
  props: {
    profile: {
      profile: true,
      type: Object
    },
    title: {
      required: false,
      type: String,
      default: "Media"
    }
  },

  created() {
    this.media = Object.assign([], this.profile.media);
    this.$bus.$on("media-uploaded", mediaElement => {
      if (mediaElement) {
        this.media.push(mediaElement);
        this.recentlyUploadedMedia.push(mediaElement);
      }
    });
    this.$bus.$on("media-changed", mediaElement => {
      if (mediaElement) {
        let change_media_idx = this.media.findIndex(
          el => el.id === mediaElement.id
        );
        if (mediaElement.is_primary) {
          let old_primary_idx = mediaElement.is_image
            ? this.media.findIndex(el => {
                return el.is_primary && el.is_image;
              })
            : this.media.findIndex(el => {
                return el.is_primary && el.is_audio;
              });
          if (old_primary_idx >= 0 && old_primary_idx != change_media_idx) {
            let non_primary_media = Object.assign(
              {},
              this.media[old_primary_idx]
            );
            non_primary_media.is_primary = false;
            this.$set(this.media, old_primary_idx, non_primary_media);
          }
        }
        this.$set(this.media, change_media_idx, mediaElement);
        change_media_idx = this.recentlyUploadedMedia.findIndex(
          el => el.id === mediaElement.id
        );
        this.$set(this.recentlyUploadedMedia, change_media_idx, mediaElement);
      }
    });
    this.$bus.$on("media-deleted", mediaElement => {
      if (mediaElement) {
        let idx = this.media.findIndex(el => el.id === mediaElement.id);
        this.$delete(this.media, idx);
        idx = this.recentlyUploadedMedia.findIndex(
          el => el.id === mediaElement.id
        );
        this.$delete(this.recentlyUploadedMedia, idx);
      }
    });
  },
  methods: {
    destroy(media) {
      return new Promise(resolve => {
        this.$http.delete(media.delete_url).then(() => {
          this.$bus.$emit("media-deleted", media);
          resolve();
        });
      });
    }
  },
  computed: {
    audioFiles() {
      return this.media.filter(media => {
        return media.is_audio;
      });
    },
    pictures() {
      return this.media.filter(media => {
        return media.is_image;
      });
    }
  },
  destroyed() {
    this.$bus.$off("media-uploaded");
    this.$bus.$off("media-changed");
    this.$bus.$off("media-deleted");
  }
};
</script>
